/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Deice Icon component.
 */
export const AssetDeviceIcon = (props: IconProps) => {
  const {color, size = IconSize.large, stroke} = props;
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
      <path d='M20.891 13.3047H3C2.72386 13.3047 2.5 13.5285 2.5 13.8047V27.015C2.5 27.2912 2.72386 27.515 3 27.515H20.891C21.1671 27.515 21.391 27.2912 21.391 27.015V13.8047C21.391 13.5285 21.1671 13.3047 20.891 13.3047Z' fill={iconColor}/>
      <path d='M24.7932 26.8316C26.2195 26.4667 27.4828 25.6354 28.3822 24.4698C29.2816 23.3043 29.7656 21.8715 29.757 20.3992C29.7483 18.927 29.2477 17.5 28.3347 16.3451C27.4217 15.1901 26.1487 14.3736 24.7183 14.0254' stroke={stroke as any} strokeWidth='1.5' strokeMiterlimit='10'/>
      <path d='M26.9475 30.8569C29.2652 30.256 31.3162 28.899 32.7755 27.0008C34.2349 25.1026 35.0192 22.7717 35.0041 20.3774C34.9891 17.9831 34.1756 15.6623 32.6925 13.7825C31.2094 11.9028 29.1415 10.5717 26.8164 10' stroke={stroke as any} strokeWidth='1.5' strokeMiterlimit='10'/>
    </svg>
  );
};

export default AssetDeviceIcon;
